import { useAuthUser } from "../../auth/hooks/useAuthUser";
import { useRefreshUser } from "../../auth/hooks/useRefreshUser";

export function useAuthUserSignalProviders() {
  const { user } = useAuthUser();
  const refresh = useRefreshUser();
  const providers = user?.signal_providers || [];

  return { providers, refresh }
}